<script>
	import {state} from '@sock/state'
	import {server, connected} from '@sock/connection'
</script>

{#if $connected}
<h2>{$server}</h2>

<ul>
{#if $state.inputs}
	{#each [...$state.inputs] as input}
		<li>
			{input.number}:
			{input.number === $state.active ? 'ACTIVE' : ''}
			{input.number === $state.preview ? 'PREVIEW' : ''}
			{input.title}
			({input.type}, {input.state})
	{/each}
{/if}
</ul>
{:else}
<h2>Not connected</h2>
{/if}
